import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import dayjs from "dayjs";

/**
 * GenerateFornecedorAvaliacaoColumnDefinition
 */

type Props = {
  onActionEditar: (idAvaliacaoFornecedor: number | null, openState: boolean) => void;
  onActionDelete: (idBanco: number | null, openState: boolean) => void;
};

export const GenerateFornecedorAvaliacaoColumnDefinition = ({
  onActionEditar,
  onActionDelete,
}: Props): GridColDef[] => {
  return [
    {
      field: "data",
      filterable: false,
      headerName: "Data da Avaliação",
      minWidth: 80,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <span>{value && dayjs(value).format('DD/MM/YYYY')}</span>
        );
      }
    },
    {
      field: "nome",
      filterable: false,
      headerName: "Responsável Pela Avaliação",
      minWidth: 250,
      sortable: false,
    },
    {
      field: "nrOrdemCompra",
      filterable: false,
      headerName: "N° da OC",
      width: 80,
      minWidth: 80,
      sortable: false,
    },
    {
      field: "centroCusto",
      filterable: false,
      headerName: "Centro de Custo",
      minWidth: 150,
      sortable: false,
    },
    {
      field: "nroNotaFiscal",
      filterable: false,
      headerName: "N° da nota fiscal",
      minWidth: 120,
      sortable: false,
    },
    {
      field: "observacao",
      filterable: false,
      headerName: "Observações",
      flex: 1,
      minWidth: 150,
      sortable: false,
    },
    {
      field: "mediaNota",
      filterable: false,
      headerName: "Nota Média",
      minWidth: 100,
      sortable: false,
      renderCell: ({ value }) => {
        return (
          <span>{value && value.toFixed(2).replaceAll('.', ',')}</span>
        );
      }
    },
    {
      field: 'idAvaliacaoFornecedor',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      resizable: false,
      renderCell: ({ value }) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton
              onMouseDown={e => {
                onActionEditar(value, true);
                e.preventDefault();
              }}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => { onActionDelete(value, true) }}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}